(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chef-ambassadors"] && !Shopify.designMode) return;
  try {
    
  $('.js-chef-carousel').flickity({
    // options
    //  cellAlign: 'left',
    // contain: true,
    // groupCells: 1,
    wrapAround: true,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  // Open on subscribe_btn (accordion style)
  $(document).on('click', '.collection-slide .subscribe_btn', function (e) {
    e.preventDefault();

    let $slide = $(this).closest('.collection-slide');

    // remove open from all slides first
    $('.collection-slide').removeClass('open');

    // then add only to the clicked one
    $slide.addClass('open');
  });

  // Close on close_card
  $(document).on('click', '.collection-slide .close_card', function (e) {
    e.preventDefault();

    let $slide = $(this).closest('.collection-slide');

    // remove open from this slide
    $slide.removeClass('open');
  });

  $(document).on('click', '.add_to_cart_btn', function (e) {
    e.preventDefault();

    var $btn = $(this);
    var variantId = $btn.data('variant-id');
    var quantity = 1; // change if needed
    $btn.prop('disabled', true).addClass('loading');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: quantity,
      },
      dataType: 'json',
      success: function (response) {
        console.log('✅ Added to cart:', response);
        // Optional: redirect to cart
        window.location.href = '/cart';
      },
      error: function (xhr, status, error) {
        console.error('❌ Error adding to cart:', xhr.responseText);
      },
      complete: function () {
        // Always re-enable button and remove loading class
        $btn.prop('disabled', false).removeClass('loading');
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evoo-carousel-sub"] && !Shopify.designMode) return;
  try {
    
  (function($){
    var evooCarousel = null;

    function initCarousel()
    {
        if(evooCarousel != null){
          evooCarousel.destroy();
        }
        evooCarousel = new Flickity('.js-evoo-carousel', {
          // options
          cellAlign: 'center',
          contain: true,
          autoPlay: false,
          pauseAutoPlayOnHover: true,
          initialIndex: isDesktop() ? 0 : 0
        });

        // Total number of slides
      var totalSlides = evooCarousel.cells.length;
      // Handle slide changes
      // evooCarousel.on('change', function(index) {
      //   if (isDesktop()) {
      //     // Skip first index (0) only on desktop
      //     if (index === 0) {
      //       evooCarousel.select(index + 1);
      //       return;
      //     }
      //     if (index === totalSlides - 1) {
      //       evooCarousel.select(index - 1);
      //     }
      //   }
      // });
    }
    
    // Function to check if desktop
    function isDesktop() {
      return window.innerWidth >= 1024; // adjust breakpoint as needed
    }

    initCarousel();
    var lastViewPort = 0;
    $(window).on('resize', function() {
      if (isDesktop()) {
        currentViewPort = 0
      }else{
        currentViewPort = 1;
      }
			if (currentViewPort != lastViewPort) {
        initCarousel();
        lastViewPort = currentViewPort;
      }
		});
  })(jQuery);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evoo-carousel"] && !Shopify.designMode) return;
  try {
    
  (function($){
    var evooCarousel = null;

    function initCarousel()
    {
        if(evooCarousel != null){
          evooCarousel.destroy();
        }
        evooCarousel = new Flickity('.js-evoo-carousel', {
          // options
          cellAlign: 'center',
          contain: true,
          autoPlay: false,
          pauseAutoPlayOnHover: true,
          initialIndex: isDesktop() ? 0 : 0
        });

        // Total number of slides
      var totalSlides = evooCarousel.cells.length;
      // Handle slide changes
      // evooCarousel.on('change', function(index) {
      //   if (isDesktop()) {
      //     // Skip first index (0) only on desktop
      //     if (index === 0) {
      //       evooCarousel.select(index + 1);
      //       return;
      //     }
      //     if (index === totalSlides - 1) {
      //       evooCarousel.select(index - 1);
      //     }
      //   }
      // });
    }
    
    // Function to check if desktop
    function isDesktop() {
      return window.innerWidth >= 1024; // adjust breakpoint as needed
    }

    initCarousel();
    var lastViewPort = 0;
    $(window).on('resize', function() {
      if (isDesktop()) {
        currentViewPort = 0
      }else{
        currentViewPort = 1;
      }
			if (currentViewPort != lastViewPort) {
        initCarousel();
        lastViewPort = currentViewPort;
      }
		});
  })(jQuery);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
/*$('.js-related-products-carousel').flickity({
        // options
        cellAlign: 'center',
        contain: true,
        autoPlay: 5000,
        pauseAutoPlayOnHover: true,
    });*/
	(function($) {

		window.onload = function() {
			initCarousel();
		};
		var lastViewPort = 0;
		$(window).on('resize', function() {
			if (isDesktop()) {
				currentViewPort = 0
			}else{
				currentViewPort = 1;
			}
			if (currentViewPort != lastViewPort) {
				initCarousel();
				lastViewPort = currentViewPort;
			}
		});
		var evooCarousel = null;
		function initCarousel()
		{
			if(evooCarousel != null){
				evooCarousel.destroy();
			}
			const $carousel = document.querySelector('.js-related-products-carousel');
			if ($carousel) {
				evooCarousel = new Flickity($carousel, {
					cellAlign: 'center',
					contain: true,
					autoPlay: 5000,
					pauseAutoPlayOnHover: true,
					pageDots: true,
					initialIndex: isDesktop() ? 0 : 0
				});
				// Total number of slides
				var totalSlides = evooCarousel.cells.length;

				// Handle slide changes
				// evooCarousel.on('change', function(index) {
				// 	if (isDesktop()) {
				// 		// Skip first index (0) only on desktop
				// 		if (index === 0) {
				// 			evooCarousel.select(index + 1);
				// 			return;
				// 		}
				// 		if (index === totalSlides - 1) {
				// 			evooCarousel.select(index - 1);
				// 		}
				// 	}
				// });
			}
		}
		// Function to check if desktop
		function isDesktop() {
			return window.innerWidth >= 1024; // adjust breakpoint as needed
		}
	})(jQuery);
	// window.onload = function() {
	// 	const $carousel = document.querySelector('.js-related-products-carousel');
	// 	if ($carousel) {
	// 		new Flickity($carousel, {
	// 		cellAlign: 'center',
	// 		contain: true,
	// 		autoPlay: 5000,
	// 		pauseAutoPlayOnHover: true,
	// 		pageDots: true
	// 		});
	// 	}
	// };

// Open on subscribe_btn (accordion style)
$(document).on('click', '.collection-slide .subscribe_btn', function(e) {
  e.preventDefault();

  let $slide = $(this).closest('.collection-slide');

  // remove open from all slides first
  $('.collection-slide').removeClass('open');

  // then add only to the clicked one
  $slide.addClass('open');
});

// Close on close_card
$(document).on('click', '.collection-slide .close_card', function(e) {
  e.preventDefault();

  let $slide = $(this).closest('.collection-slide');

  // remove open from this slide
  $slide.removeClass('open');
});

$(document).on('click','.add_to_cart_btn', function(e) {
  e.preventDefault();

  var $btn = $(this);
  var variantId = $btn.data('variant-id');
  var quantity = 1; // change if needed
  $btn.prop('disabled', true).addClass('loading');
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: variantId,
      quantity: quantity
    },
    dataType: 'json',
    success: function(response) {
      console.log('✅ Added to cart:', response);
      // Optional: redirect to cart
      window.location.href = '/cart';
    },
    error: function(xhr, status, error) {
      console.error('❌ Error adding to cart:', xhr.responseText);
    },
    complete: function() {
      // Always re-enable button and remove loading class
      $btn.prop('disabled', false).removeClass('loading');
    }
  });
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-customers-think"] && !Shopify.designMode) return;
  try {
    

$('.js-testimonial-carousel').flickity({
  cellAlign: 'center',
  contain: true,
//  wrapAround: true,
  autoPlay: 5000,
  pauseAutoPlayOnHover: true,
  prevNextButtons: false,
  pageDots: false
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["your-perfect-evoo"] && !Shopify.designMode) return;
  try {
    
  (function($){
    var lastViewPort = 0;
    $(window).on('resize', function() {
      if (isDesktop()) {
        currentViewPort = 0
      }else{
        currentViewPort = 1;
      }
			if (currentViewPort != lastViewPort) {
        initCarousel();
        lastViewPort = currentViewPort;
      }
		});
		var evooCarousel = null;

    function initCarousel()
		{
			if(evooCarousel != null){
				evooCarousel.destroy();
			}
      evooCarousel = new Flickity('.js-collection-carousel', {
        // options
        cellAlign: 'left',
        contain: true,
        initialIndex: isDesktop() ? 0 : 0
      });

      // Total number of slides
      var totalSlides = evooCarousel.cells.length;

      
      // Handle slide changes
      evooCarousel.on('change', function(index) {
        // if (isDesktop()) {
        //   if (index === 0) {
        //     evooCarousel.select(index + 1);
        //     return;
        //   }
        //   if (index === totalSlides - 1) {
        //     evooCarousel.select(index - 1);
        //   }
        // }
      });
    }
    // Function to check if desktop
    function isDesktop() {
      return window.innerWidth >= 1024;
    }

    initCarousel();

    // $('.js-collection-carousel .flickity-slider').addClass('active');    
  })(jQuery);

  // Open on subscribe_btn (accordion style)
  $(document).on('click', '.collection-slide .subscribe_btn', function (e) {
    e.preventDefault();

    let $slide = $(this).closest('.collection-slide');

    // remove open from all slides first
    $('.collection-slide').removeClass('open');

    // then add only to the clicked one
    $slide.addClass('open');
  });

  // Close on close_card
  $(document).on('click', '.collection-slide .close_card', function (e) {
    e.preventDefault();

    let $slide = $(this).closest('.collection-slide');

    // remove open from this slide
    $slide.removeClass('open');
  });

  $(document).on('click', '.add_to_cart_btn', function (e) {
    e.preventDefault();

    var $btn = $(this);
    var variantId = $btn.data('variant-id');
    var quantity = 1; // change if needed
    $btn.prop('disabled', true).addClass('loading');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: quantity,
      },
      dataType: 'json',
      success: function (response) {
        console.log('✅ Added to cart:', response);
        // Optional: redirect to cart
        window.location.href = '/cart';
      },
      error: function (xhr, status, error) {
        console.error('❌ Error adding to cart:', xhr.responseText);
      },
      complete: function () {
        // Always re-enable button and remove loading class
        $btn.prop('disabled', false).removeClass('loading');
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
